import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRecurringRegularIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 16 16",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M12.8 4.4q.3-.3 0-.7l-2-2a.5.5 0 0 0-.7.7l1 1.1H6.6a4 4 0 0 0-4.2 4.3.5.5 0 1 0 1 0c0-1.8 1.4-3.2 3.2-3.2H11l-1 1q-.3.4 0 .8.3.3.7 0zm-9.6 6.4v.7l2 2q.3.3.7 0 .3-.5 0-.8l-1-1h4.5c2.3 0 4.2-2 4.2-4.3a.5.5 0 1 0-1 0c0 1.8-1.4 3.2-3.2 3.2H5l1-1q.3-.4 0-.8h-.7z" })
});
export default SvgRecurringRegularIcon;
